import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Group} from '../../../../../models/group.model';
import {Position} from '../../../../../models/position.model';
import {AdminService} from '../../../../../services/admin.service';
import {FullUser} from '../../../../../models/full-user.model';
import {GroupUser} from '../../../../../models/group-user.model';

@Component({
  selector: 'app-add-member-popup',
  templateUrl: './add-member-popup.component.html',
  styleUrls: ['./add-member-popup.component.css'],
})
export class AddMemberPopupComponent implements OnInit {

  @Input() name;
  public group: Group;
  public selectedPosition: Position;
  public selectedUser: FullUser;
  public users;

  public allPositions;

  public successInfo = false;
  public already = false;
  public errorInfo = false;
  public isLoaded = false;

  addDisabled = true;

  searchUserText;
  searchPositionText;

  constructor(public activeModal: NgbActiveModal,
              private adminService: AdminService) {
  }

  ngOnInit() {

    this.adminService.getUserOutSide(this.group.id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          const users = response.body;
          this.users = users;
          const preselect = {
            id: '',
            login: '',
            password: '',
            firstName: '',
            lastName: 'SELECT_USER',
            patronymicName: '',
            dateOfEmployment: '',
            dateOfDismissal: '',
            language: '',
            roles: [],
            schedule: '',
            status: '',
            internalNumber: '',
            remoteAccessAllowed: false,
            phone: '',
            email: '',
            testingDisabled: false,
            mainGroup: '',
            familiarizationDays: null
          };
          this.selectedUser = preselect;
          this.isLoaded = true;
        }
      },
      () => {
        this.isLoaded = true;
      });

    this.adminService.getActivePositions().subscribe(
      (res: any) => {
        this.allPositions = res.body;
        this.selectedPosition = this.allPositions[0];
      },
      () => {
      }
    );
  }

  setGroup(group: Group) {
    this.group = group;
  }

  selectedP(position: Position) {
    this.selectedPosition = position;
  }

  selectUser(user: FullUser) {
    this.selectedUser = user;
    this.addDisabled = false;
  }

  addMember() {
    this.isLoaded = false;
    this.adminService.putUserOfGroup(this.group.id, this.selectedUser.id, this.selectedPosition.id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.group.activeUsers.push(new GroupUser(this.selectedUser, this.selectedPosition));

          this.successInfo = true;
          this.already = false;
          this.errorInfo = false;
          this.isLoaded = true;
        }
        if (response.status === 208) {
          this.successInfo = false;
          this.already = true;
          this.errorInfo = false;
          this.isLoaded = true;
        }
        if (response.status === 412) {
          this.successInfo = false;
          this.already = false;
          this.errorInfo = true;
          this.isLoaded = true;
        }
      },
      () => {
        this.isLoaded = true;
        this.errorInfo = true;
      });
  }

  filterBy(prop: string, list: string) {
    if (list === 'users') {
      if (this.users !== undefined) {
        return this.users.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
      }
    }
    if (list === 'positions') {
      if (this.allPositions !== undefined) {
        return this.allPositions.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/add-member-popup/add-member-popup.component.ts